import React from 'react';
import { BadgeCheckIcon, ClockIcon, MapPinIcon } from 'lucide-react';
import { MatchForm } from './MatchForm';
const assurances = [{
  icon: MapPinIcon,
  title: 'Local, certified providers only',
  body: 'Every practice in our network is trained and certified on the device.'
}, {
  icon: ClockIcon,
  title: 'A reply within one business day',
  body: 'You pick the times that work; they confirm around your schedule.'
}, {
  icon: BadgeCheckIcon,
  title: 'Free, no-pressure consultation',
  body: 'Get an honest candidacy assessment and a quote before committing.'
}];
export function FinalCta() {
  return <section id="consult" className="w-full bg-ash-900 py-20 text-white lg:py-28" data-id="element-43" data-mp="1t37s9iqmb5zk">
      <div className="mx-auto grid w-full max-w-7xl gap-14 px-5 lg:grid-cols-[1fr_0.95fr] lg:items-start lg:gap-20 lg:px-8" data-id="element-44" data-mp="1o43mz36tdsei">
        <div data-id="element-45" data-mp="224o31rlcha4b">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-turq-300" data-id="element-46" data-mp="2245ze9wcrtmd">Find your provider</p>
          <h2 className="mt-4 max-w-xl font-display text-4xl leading-tight tracking-tight lg:text-5xl" data-id="element-47" data-mp="1x64dzibgfi7q">
            Two minutes now, a decade off your jawline
          </h2>
          <p className="mt-5 max-w-lg text-lg leading-relaxed text-white/70" data-id="element-48" data-mp="s5qopxrp58uq">
            Tell us where you are and what you&apos;d like lifted. We&apos;ll connect you with a certified provider
            near you for a complimentary consultation.
          </p>
          <ul className="mt-10 space-y-7" data-id="element-49" data-mp="164gl1b6oz4i1">
            {assurances.map(item => <li key={item.title} className="flex gap-4" data-id="element-50" data-mp="162m9uol82qr5">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/10 text-turq-300" data-id="element-51" data-mp="1b28ngz4yq90h">
                  <item.icon className="h-5 w-5" aria-hidden="true" data-id="element-52" data-mp="1fwcx5q5m4v59" />
                </span>
                <div data-id="element-53" data-mp="1ksl4wihhdm2e">
                  <p className="font-semibold" data-id="element-54" data-mp="1kv7gct7hslpw">{item.title}</p>
                  <p className="mt-1 max-w-sm text-sm leading-relaxed text-white/60" data-id="element-55" data-mp="1pu0riezb40mw">{item.body}</p>
                </div>
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl bg-white/5 p-6 ring-1 ring-white/15 sm:p-8" data-id="element-56" data-mp="3qvqidrtugwkb">
          <h3 className="font-display text-2xl" data-id="element-57" data-mp="3lw44rha3teaz">Request your free consult</h3>
          <p className="mt-1 text-sm text-white/60" data-id="element-58" data-mp="3hl6rarsgke7">Takes under two minutes.</p>
          <div className="mt-6" data-id="element-59" data-mp="3jpkekfhoxro">
            <MatchForm onDark data-id="element-60" data-mp="3uvqxzfsojdsy" />
          </div>
        </div>
      </div>
    </section>;
}